import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export default function Register() {
  const [name, setName]         = useState('');
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [loading, setLoading]   = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !email || !password || !confirm) return toast.error('Please fill all fields');
    if (password !== confirm) return toast.error('Passwords do not match');
    if (password.length < 6)  return toast.error('Password must be at least 6 characters');
    setLoading(true);
    try {
      const data = await register(name.trim(), email.trim(), password);
      navigate(data.redirectTo, { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@700&family=Exo+2:wght@400;600;700;900&display=swap');
        *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
        @keyframes fadeUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
        .rcard{animation:fadeUp .5s ease both}
        .rinput:focus{border-color:rgba(245,166,35,.5)!important;outline:none}
        .rbtn:hover{background:#00d4a0!important;transform:translateY(-1px)}
      `}</style>
      <div style={s.bgGrid} />
      <div style={s.bgGlow} />

      <div className="rcard" style={s.card}>
        <div style={s.logo}>
          <img src="/logo.jpg" alt="MegaFishHub" style={{ height: '80px', width: 'auto', objectFit: 'contain', marginBottom: '8px' }} />
          <span style={s.logoSub}>CREATE YOUR ACCOUNT</span>
        </div>

        <form onSubmit={handleSubmit} style={s.form}>
          {[
            { label: 'PLAYER NAME', value: name,     set: setName,     type: 'text',     ph: 'Your full name' },
            { label: 'EMAIL',       value: email,    set: setEmail,    type: 'email',    ph: 'your@email.com' },
            { label: 'PASSWORD',    value: password, set: setPassword, type: 'password', ph: 'Min 6 characters' },
            { label: 'CONFIRM PASSWORD', value: confirm, set: setConfirm, type: 'password', ph: 'Repeat password' },
          ].map(f => (
            <div key={f.label} style={s.field}>
              <label style={s.label}>{f.label}</label>
              <input className="rinput" style={s.input} type={f.type} placeholder={f.ph}
                value={f.value} onChange={e => f.set(e.target.value)} />
            </div>
          ))}
          <button className="rbtn" style={{ ...s.btn, opacity: loading ? 0.7 : 1 }} disabled={loading}>
            {loading ? 'Creating account...' : 'JOIN MEGAFISHHUB →'}
          </button>
        </form>

        <p style={s.switchText}>
          Already a player? <Link to="/login" style={s.switchLink}>Sign In</Link>
        </p>
      </div>
    </div>
  );
}

const s = {
  page: { minHeight: '100vh', background: '#080c14', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontFamily: "'Exo 2',sans-serif", position: 'relative', overflow: 'hidden' },
  bgGrid: { position: 'fixed', inset: 0, backgroundImage: 'linear-gradient(rgba(245,166,35,.03) 1px,transparent 1px),linear-gradient(90deg,rgba(245,166,35,.03) 1px,transparent 1px)', backgroundSize: '50px 50px', pointerEvents: 'none' },
  bgGlow: { position: 'fixed', top: '-30%', right: '-10%', width: '70vw', height: '70vw', background: 'radial-gradient(circle,rgba(0,212,255,.05) 0%,transparent 70%)', pointerEvents: 'none' },
  card: { width: '100%', maxWidth: '420px', background: '#0d1420', borderRadius: '20px', border: '1px solid rgba(245,166,35,.15)', padding: '36px', position: 'relative', zIndex: 1 },
  logo: { display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '28px' },
  logoText: { fontFamily: "'Rajdhani',sans-serif", fontSize: '40px', fontWeight: '700', color: '#f5a623', letterSpacing: '12px', textShadow: '0 0 20px rgba(245,166,35,.5)', marginTop: '8px' },
  logoSub: { color: 'rgba(255,255,255,.25)', fontSize: '11px', letterSpacing: '4px', marginTop: '6px' },
  form: { display: 'flex', flexDirection: 'column', gap: '16px' },
  field: { display: 'flex', flexDirection: 'column', gap: '7px' },
  label: { color: 'rgba(245,166,35,.7)', fontSize: '11px', fontWeight: '700', letterSpacing: '3px' },
  input: { background: 'rgba(255,255,255,.04)', border: '1px solid rgba(245,166,35,.15)', borderRadius: '12px', padding: '13px 16px', color: '#fff', fontSize: '15px', fontFamily: "'Exo 2',sans-serif", transition: 'border-color .2s' },
  btn: { background: '#f5a623', border: 'none', borderRadius: '12px', padding: '15px', color: '#080c14', fontSize: '15px', fontWeight: '900', letterSpacing: '2px', cursor: 'pointer', marginTop: '6px', fontFamily: "'Rajdhani',sans-serif", transition: 'all .2s' },
  switchText: { textAlign: 'center', color: 'rgba(255,255,255,.3)', fontSize: '14px', marginTop: '22px' },
  switchLink: { color: '#f5a623', fontWeight: '700', textDecoration: 'none' },
};
